{
  "product-happy-hour-dialog": {
    "buttons": {
      "close": "Schließen"
    },
    "text": {
      "happy-hour": "Happy hour",
      "to": "zu"
    }
  },
  "product-promotion-dialog": {
    "buttons": {
      "close": "Schließen"
    },
    "text": {
      "from-date-to-date": "von {{from}} bis {{to}}"
    }
  },
  "salon-service-selection": {
    "buttons": {
      "select": "Auswählen",
      "selected": "Ausgewählt"
    },
    "text": {
      "discount-details": "Details zum Rabatt",
      "minutes": "Minuten"
    }
  }
}
